<script>
    import { TextInput } from "carbon-components-svelte";
    import Delete from "carbon-icons-svelte/lib/Delete.svelte";
    import { Grid, Row, Column } from "carbon-components-svelte";
    import { createEventDispatcher, onMount } from 'svelte';
        
    import YardMaterialPrices from "./YardMaterialPrices.svelte";
    
    const dispatch = createEventDispatcher()
    
    export let material = { }
    // I export this value so I can pass back the width of the material name
    // so I can set the label width in the parent component 
    export let widths = {
        materialNameRowWidth: 0,
        materialNameFieldWidth: 0
    };

    onMount(async () => {
		widths.materialNameFieldWidth = document.getElementById("materialNameField").offsetWidth
	});

    function deleteMaterial(material) {
        dispatch('delete-material', material)
	}

    function updatePrices(event) {
        let prices = event.detail
        material.prices = prices
        dispatch("update-material", material)
    }

</script>

<div class="material-category-card">
    <div class="material-title-bar">
        <button class="delete-cat-btn" on:click={() => deleteMaterial(material)} title="Remove Material Category" type="button">
            <Delete size={16} />
        </button>
        <div class="cat-input-box">
            <TextInput 
                id="materialNameField" 
                hideLabel 
                size="sm" 
                labelText="Category Name" 
                placeholder="e.g. Concrete, Soil, Mixed Waste"
                bind:value={material.name} 
                on:input={() => dispatch("update-material", material)}
            /> 
        </div>
    </div>
    <div class="material-prices-body">
        <YardMaterialPrices bind:prices={material.prices} on:price-updated={updatePrices}/>
    </div>
</div>

<style>
    .material-category-card {
        background-color: #ffffff;
        border: 1px solid var(--tt-slate-200);
        border-radius: 12px;
        padding: 10px 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

    .material-category-card:hover {
        border-color: var(--tt-slate-300);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    }

    .material-title-bar {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .delete-cat-btn {
        background: transparent;
        border: none;
        color: var(--tt-slate-400);
        cursor: pointer;
        padding: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.15s ease;
    }

    .delete-cat-btn:hover {
        color: var(--tt-danger);
        background-color: var(--tt-danger-bg);
    }

    .cat-input-box {
        flex: 1;
    }

    :global(.cat-input-box .bx--text-input) {
        font-weight: 600 !important;
        color: var(--tt-slate-900) !important;
        height: 34px !important;
        font-size: 13px !important;
        border-radius: 8px !important;
        border: 1px solid var(--tt-slate-200) !important;
        background-color: #f8fafc !important;
    }

    :global(.cat-input-box .bx--text-input:focus) {
        border-color: var(--tt-primary) !important;
        background-color: #ffffff !important;
        box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.15) !important;
    }

    .material-prices-body {
        padding-left: 32px;
    }
</style>